import { render } from "./BoxList.vue?vue&type=template&id=d767d08a&ts=true"
import script from "./BoxList.vue?vue&type=script&lang=ts"
export * from "./BoxList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__